module.exports = __webpack_public_path__ + "static/media/ts.64ca9e3.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/ts.wav
// module id = AbZB
// module chunks = 137